import React from 'react';
import { Route } from 'react-router-dom';

import 'src/App.scss';
import './style.scss';

import Entrar from './Entrar';
import Recuperar from './Recuperar';

function Login() {
  return (
    <div className="loginPage">
      <div className="bgFade" />
      <div className="bgLight" />
      <div className="fadeOut absoluteCenter" />

      <div className="loginWrapper absoluteCenter mainShadow mainBorderRadius">
        <Route path={['/', '/login', '/login/*']} component={Entrar} exact />
        <Route path={['/recuperarsenha']} component={Recuperar} exact />
      </div>
    </div>
  );
}

export default Login;
